import { Component, Input, OnInit } from '@angular/core';

import { SlimLoadingBarService, SlimLoadingBarEvent, SlimLoadingBarEventType } from 'ng2-slim-loading-bar';

@Component({
    selector: 'ui-overlay',
    template: `
<div class="overlay" [style.visibility]="isVisible ? 'visible' : 'hidden'">
    <div class="preloader4"></div>
</div>`
})
export class UiOverlayComponent implements OnInit {

    @Input()
    isVisible: boolean = false;

    constructor(public service: SlimLoadingBarService) { }

    ngOnInit(): any {
        this.service.events.subscribe((event: SlimLoadingBarEvent) => {

            //if (event.type === SlimLoadingBarEventType.VISIBLE) {
            //    this.isVisible = event.value;
            //}
        });
    }
}


// WEBPACK FOOTER //
// ./app/common/uioverlay/ui-overlay.service.ts